import { colors } from "@styles/colors";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { View, YStack, ScrollView } from "tamagui";
interface RadiusContentWrapperProps {
  children: React.ReactNode;
  padding?: string;
  disableScroll?: boolean;
  space?: any;
  contentContainerStyle?: any;
  /** 內容捲動時回報 scrollTop 與可捲距離（供上層做 header 收合等）。 */
  onScrollChange?: (y: number, room: number) => void;
  /** 內容區底色。預設 colors.bg；傳 "transparent" 可讓外層（如整頁漸層）透出來。 */
  background?: string;
  /** 外層容器的額外 class（如 Skin V2 的頂端淡出遮罩）。 */
  className?: string;
}

const RadiusContentWrapper = ({
  children,
  padding = "$4",
  disableScroll = false,
  space = "$6",
  contentContainerStyle,
  onScrollChange,
  background = colors.bg,
  className,
}: Readonly<RadiusContentWrapperProps>) => {
  const pathname = useLocation();
  const scrollRef = useRef<ScrollView>(null);
  useEffect(() => {
    const scrollToTop = () => {
      if (scrollRef.current) {
        // @ts-ignore - Tamagui's ScrollView on web has scrollTo
        scrollRef.current.scrollTo({ y: 0, animated: false });
      }
    };

    // 監聽全局事件，讓子組件可以透過 window.dispatchEvent(new Event('scroll-to-top')) 觸發捲動
    window.addEventListener("scroll-to-top", scrollToTop);

    // 同時監聽路徑變化
    scrollToTop();

    return () => window.removeEventListener("scroll-to-top", scrollToTop);
  }, [pathname]);
  return (
    <View flex={1} backgroundColor={background} p={padding} className={className}>
      {disableScroll ? (
        // 不捲動的頁面（如付款方式卡帶）：內容自己吃滿內容區高度；contentContainerStyle 的 paddingTop
        // （Skin V2 absolute 標題列的讓位）同樣要套，否則內容會塞到標題列底下。
        <YStack flex={1} minHeight={0} space={space} style={contentContainerStyle}>
          {children}
        </YStack>
      ) : (
        <ScrollView
          className="tamagui-scrollview"
          showsVerticalScrollIndicator={false}
          width="100%"
          ref={scrollRef}
          onScroll={
            onScrollChange
              ? (e: any) => {
                  const ne = e?.nativeEvent;
                  const el = e?.target;
                  const y = ne?.contentOffset?.y ?? el?.scrollTop ?? 0;
                  const contentH = ne?.contentSize?.height;
                  const viewH = ne?.layoutMeasurement?.height;
                  const room = contentH != null && viewH != null ? contentH - viewH : el ? (el.scrollHeight ?? 0) - (el.clientHeight ?? 0) : 0;
                  onScrollChange(y, room);
                }
              : undefined
          }
          scrollEventThrottle={16}
          contentContainerStyle={{ flexGrow: 1, ...contentContainerStyle }}
        >
          <YStack space={space} flex={1}>
            {children}
          </YStack>
        </ScrollView>
      )}
    </View>
  );
};

export default RadiusContentWrapper;
